import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalComponent, NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import {
  exportApprovesFailureAction,
  exportApprovesSuccessAction,
} from '@modules/regular-user/approves/application/store/approves.actions';
import {
  exportRequestsAction,
  exportRequestsSuccessAction,
} from '@modules/regular-user/requests/application/store/requests.actions';
import { Actions, ofType } from '@ngrx/effects';
import { isNil } from 'lodash';
import { filter, map, Subject, takeUntil, tap } from 'rxjs';
import { AccountSetupCompleteModal } from '../account-setup-complete/account-setup-complete.modal';

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss'],
})
export class ExportModal extends ModalComponent implements OnInit, OnDestroy {
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  constructor(
    private actions$: Actions,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<AccountSetupCompleteModal>,
    private notificationService: NotificationsService
  ) {
    super();
  }

  ngOnInit(): void {
    /**
     * Handle Error
     */
    this.onFailureActions();

    this.actions$
      .pipe(
        ofType(exportApprovesSuccessAction, exportRequestsSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action) => {
          this.notificationService.success('Exported Successfully', {
            duration: 3000,
            icon: 'check-circle',
          });
          this.closeModal();
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  closeModal() {
    this.dialogRef.close();
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(exportApprovesFailureAction),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
